/* tslint:disable */
/* eslint-disable */
/**
 * Melco Digitizing APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DigitizingserviceMelcoDigitizingModelsTempOrderCompleteAttachment
 */
export interface DigitizingserviceMelcoDigitizingModelsTempOrderCompleteAttachment {
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsTempOrderCompleteAttachment
     */
    file_url?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsTempOrderCompleteAttachment
     */
    file_extension?: string | null;
}

export function DigitizingserviceMelcoDigitizingModelsTempOrderCompleteAttachmentFromJSON(json: any): DigitizingserviceMelcoDigitizingModelsTempOrderCompleteAttachment {
    return DigitizingserviceMelcoDigitizingModelsTempOrderCompleteAttachmentFromJSONTyped(json, false);
}

export function DigitizingserviceMelcoDigitizingModelsTempOrderCompleteAttachmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): DigitizingserviceMelcoDigitizingModelsTempOrderCompleteAttachment {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'file_url': !exists(json, 'file_url') ? undefined : json['file_url'],
        'file_extension': !exists(json, 'file_extension') ? undefined : json['file_extension'],
    };
}

export function DigitizingserviceMelcoDigitizingModelsTempOrderCompleteAttachmentToJSON(value?: DigitizingserviceMelcoDigitizingModelsTempOrderCompleteAttachment | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'file_url': value.file_url,
        'file_extension': value.file_extension,
    };
}


